<script lang="ts">
    import { twMerge } from "tailwind-merge"

    export let ariaLabel: string | undefined = undefined
    export let disabled = false
    export let type: "button" | "submit" | "reset" = "button"

    let className = ""
    export { className as class }
</script>

<button
    {...$$restProps}
    {type}
    class={twMerge("dotted-action-box", className)}
    aria-label={ariaLabel}
    {disabled}
    on:click
    on:focus
    on:blur
>
    <slot />
</button>

<style>
    .dotted-action-box {
        appearance: none;
        display: grid;
        place-items: center;
        width: 100%;
        min-height: 13rem;
        height: 100%;
        box-sizing: border-box;
        border: 1.5px dotted var(--color-purple-300);
        border-radius: 1.5rem;
        background: color-mix(in srgb, var(--color-purple-50) 44%, transparent);
        box-shadow: none;
        color: var(--color-purple-700);
        cursor: pointer;
        font: inherit;
        letter-spacing: 0;
        padding: 1rem;
        text-align: center;
        text-transform: none;
        transition:
            transform 0.16s ease,
            border-color 0.16s ease,
            background-color 0.16s ease,
            color 0.16s ease;
    }

    .dotted-action-box:hover {
        border-color: var(--color-purple-500);
        background: var(--color-purple-50);
        box-shadow: none;
        color: var(--color-purple-800);
    }

    .dotted-action-box:active {
        transform: translateY(1px);
    }

    .dotted-action-box:focus-visible {
        outline: 2px solid var(--color-gold-400);
        outline-offset: 3px;
    }

    .dotted-action-box:disabled {
        cursor: not-allowed;
        filter: grayscale(0.75);
        opacity: 0.6;
    }

    :global(.darkmode) .dotted-action-box {
        border-color: var(--color-grey-600);
        background: color-mix(in srgb, var(--color-grey-800) 72%, transparent);
        color: var(--color-purple-100);
    }

    :global(.darkmode) .dotted-action-box:hover {
        border-color: var(--color-purple-400);
        background: var(--color-grey-800);
        box-shadow: none;
        color: var(--color-grey-0);
    }
</style>
